import { Shield, Mail, ExternalLink } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import styles from '../styles/RestrictedAccess.module.css';

export function RestrictedAccess() {
  const handleContactSupport = () => {
    window.open('mailto:support@dashverse.ai?subject=Access Request for CMS Platform', '_blank');
  };

  const handleBackToLogin = () => {
    window.location.href = '/';
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.contentWrapper}>
        {/* Header */}
        <div className={styles.header}>
          <div className={styles.headerContent}>
            <span className="text-lg font-medium">Dashreels CMS</span>
          </div>
        </div>

        {/* Main Content */}
        <div className={styles.mainContent}>
          <div className={styles.container}>
            <Card className={styles.card}>
              <CardContent className={styles.cardContent}>
                {/* Icon */}
                <div className={styles.iconWrapper}>
                  <Shield className={styles.icon} />
                </div>

                {/* Title and Description */}
                <div className={styles.textContent}>
                  <h1 className={styles.title}>
                    Access Restricted
                  </h1>
                  <p className={styles.description}>
                    This platform is currently restricted to Dashverse and Dashtoon team members only.
                    Access is limited to users with <strong>@dashverse.ai</strong> or <strong>@dashtoon.com</strong> email addresses.
                  </p>
                </div>

                {/* Info Section */}
                <div className={styles.infoSection}>
                  <h3 className={styles.infoTitle}>Need Access?</h3>
                  <p className={styles.infoDescription}>
                    If you're a team member or need access to this platform, please contact our support team
                    or use your official company email address.
                  </p>
                </div>

                {/* Action Buttons */}
                <div className={styles.buttonGroup}>
                  <Button
                    onClick={handleContactSupport}
                    className={styles.primaryButton}
                  >
                    <Mail className="mr-2 h-4 w-4" />
                    Contact Support
                  </Button>
                  <Button
                    variant="outline"
                    onClick={handleBackToLogin}
                    className={styles.secondaryButton}
                  >
                    Back to Login
                  </Button>
                </div>

                {/* Additional Info */}
                <div className={styles.additionalInfo}>
                  <p className={styles.additionalInfoText}>
                    For immediate assistance, reach out to your team lead or visit our
                    <a
                      href="https://dashverse.ai"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.link}
                    >
                      company website
                      <ExternalLink className="inline ml-1 h-3 w-3" />
                    </a>
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Footer */}
        <footer className={styles.footer}>
          <div className={styles.footerContent}>
            <p className={styles.footerText}>
              © 2024 Dashverse. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}